// extracted by mini-css-extract-plugin
export default {"container":"loading_container__6Qfm1","loader":"loading_loader__0cjIW","rotation":"loading_rotation__aGLZ7"};